import { NgModule } from '@angular/core';
import { ApiService } from './services/api.service';
import { TokenService } from './services/oauth.service';
import { BlobService } from './services/blob.service';
import { NotificationModule } from '../notification';

@NgModule({
  imports: [NotificationModule],
  providers: [ApiService, BlobService, TokenService],
})
export class ApiModule {}
